import { initializeApp } from "firebase/app";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, logEvent } from "firebase/analytics";
import { getDatabase } from "firebase/database"; // ✅ add this
import { getAuth } from "firebase/auth";


// Replace this with your Firebase config from the Firebase Console
  const firebaseConfig = {
    apiKey: "AIzaSyAmW5-DYTjzT5dUtEv7fKet9wSGGZ9dPkk",
    authDomain: "wui-go-97d87.firebaseapp.com",
    projectId: "wui-go-97d87",
    storageBucket: "wui-go-97d87.appspot.com",
    messagingSenderId: "554232563465",
    appId: "1:554232563465:web:d80e376e04d815adc235d8",
    measurementId: "G-KSZXH3T53V"
  };
  
  const app = initializeApp(firebaseConfig);
  const storage = getStorage(app);
  const firestore = getFirestore(app)
  const analytics  = getAnalytics(app);
  const database = getDatabase(app);
  const auth = getAuth(app);

  export { storage, firestore, analytics, database, auth };
